module.exports = __webpack_public_path__ + "static/media/Avatars_Female-17.e4380276.png";